import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {};
const TaxFieldsFragmentDoc = gql`
    fragment TaxFields on Tax {
  code
  displayRecommendation
  amount {
    value
    currency
  }
}
    `;
const PriceFieldsFragmentDoc = gql`
    fragment PriceFields on Price {
  retailPrice {
    value
    currency
  }
  netPrice {
    value
    currency
  }
  tax {
    ...TaxFields
  }
  retailTax {
    ...TaxFields
  }
  __typename
}
    ${TaxFieldsFragmentDoc}`;
const HelpTipFieldsFragmentDoc = gql`
    fragment HelpTipFields on InclusionHelpTip {
  title
  image {
    id
    description
  }
  content
  contents {
    value
  }
}
    `;
const DisplayFieldsFragmentDoc = gql`
    fragment DisplayFields on ProductDisplay {
  panel {
    variant
  }
  title {
    enabled
    content
    variant
  }
  tagline {
    enabled
    content
    variant
  }
  banner {
    enabled
    type
    variant
  }
  cta {
    enabled
    url
    variant
  }
  custom {
    enabled
    content {
      id
    }
  }
  inclusions {
    enabled
    variant
    content {
      content
      styledContents {
        content
        variant
      }
      type
      icon {
        id
        tone
      }
      helpTip {
        ...HelpTipFields
      }
    }
    title {
      content
    }
  }
  image {
    enabled
    description
    id
  }
  price {
    enabled
    variant
  }
  expectations {
    enabled
    variant
  }
  comparatives {
    enabled
    content {
      key
      type
      content
    }
  }
  rating {
    enabled
    variant
    value
    size
  }
}
    ${HelpTipFieldsFragmentDoc}`;
const GetAdProductsForAdEditingDocument = gql`
    query GetAdProductsForAdEditing($input: AdProductsForAdEditingInput!) {
  adProductsForAdEditing(input: $input) {
    __typename
    ... on ProductList {
      __typename
      items {
        __typename
        id
        name
        ... on AdProductUpgrade {
          displayMetadata {
            name
          }
        }
        purchaseState
      }
      products {
        __typename
        id
        name
        purchaseState
        ... on AdProduct {
          addOns {
            id
            name
            price {
              __typename
              ... on HiddenPrice {
                priceVisibility
              }
              ...PriceFields
            }
            display {
              ...DisplayFields
            }
            displayMetadata {
              name
            }
          }
        }
        ... on AdProductUpgrade {
          id
          name
          price {
            __typename
            ... on HiddenPrice {
              priceVisibility
            }
            ...PriceFields
          }
          display {
            ...DisplayFields
          }
          displayMetadata {
            name
          }
        }
        display {
          ...DisplayFields
        }
      }
      display {
        __typename
        format
        sectionOrder
        sortProductIds
        productCap {
          __typename
          products
          budgets
          addons
        }
      }
    }
    ... on ProductSetExpiredError {
      __typename
      message
    }
    ... on ProductSetNotFoundError {
      __typename
      message
    }
    ... on DisplayMetadataError {
      __typename
      message
    }
  }
}
    ${PriceFieldsFragmentDoc}
${DisplayFieldsFragmentDoc}`;
function useGetAdProductsForAdEditingQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetAdProductsForAdEditingDocument, options);
}
function useGetAdProductsForAdEditingLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetAdProductsForAdEditingDocument, options);
}
function useGetAdProductsForAdEditingSuspenseQuery(baseOptions) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(GetAdProductsForAdEditingDocument, options);
}
const GetAdProductsForAdPostingDocument = gql`
    query GetAdProductsForAdPosting($input: AdProductsForAdPostingInput!, $draftId: String) {
  adProductsForAdPosting(input: $input) {
    ... on ProductSetExpiredError {
      message
    }
    ... on ProductSetNotFoundError {
      message
    }
    ... on ProductList {
      display {
        format
        sectionOrder
        productCap {
          products
        }
        sortProductIds
        content {
          comparatives {
            sections {
              title
              attributes {
                key
                title
                helpTip {
                  ...HelpTipFields
                }
                description
              }
            }
          }
        }
      }
      products {
        id
        name
        __typename
        price {
          __typename
          ... on HiddenPrice {
            priceVisibility
          }
          ...PriceFields
        }
        ... on AdProduct {
          pricing {
            ... on CappedUnitPrice {
              type
              maxBillableUnits
              unitPrice {
                ... on HiddenPrice {
                  priceVisibility
                }
                ...PriceFields
              }
              cappedPrice {
                ... on HiddenPrice {
                  priceVisibility
                }
                ...PriceFields
              }
              metadata {
                unitType
              }
            }
            __typename
          }
          display {
            ...DisplayFields
          }
          displayMetadata {
            name
          }
          upgradePaths {
            upgradeProduct {
              __typename
              id
              name
              price {
                __typename
                ... on HiddenPrice {
                  priceVisibility
                }
                ...PriceFields
              }
              display {
                ...DisplayFields
              }
              displayMetadata {
                name
              }
            }
            targetProduct2 {
              __typename
              id
              name
              ... on AdProduct {
                displayMetadata {
                  name
                }
              }
              ... on AdProductUpgrade {
                displayMetadata {
                  name
                }
              }
            }
            type
          }
          addOns {
            id
            name
            price {
              __typename
              ... on HiddenPrice {
                priceVisibility
              }
              ...PriceFields
            }
            display {
              ...DisplayFields
            }
            displayMetadata {
              name
            }
          }
          features {
            __typename
            ... on PerUnitBillingFeature {
              unit
            }
          }
          expectationForDraft(draftId: $draftId) {
            applicationsCompleted
            correlationId
            content {
              key
              value
              unit
              correlationId
            }
          }
        }
      }
    }
  }
}
    ${HelpTipFieldsFragmentDoc}
${PriceFieldsFragmentDoc}
${DisplayFieldsFragmentDoc}`;
function useGetAdProductsForAdPostingQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetAdProductsForAdPostingDocument, options);
}
function useGetAdProductsForAdPostingLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetAdProductsForAdPostingDocument, options);
}
function useGetAdProductsForAdPostingSuspenseQuery(baseOptions) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(GetAdProductsForAdPostingDocument, options);
}
export {
  DisplayFieldsFragmentDoc,
  GetAdProductsForAdEditingDocument,
  GetAdProductsForAdPostingDocument,
  HelpTipFieldsFragmentDoc,
  PriceFieldsFragmentDoc,
  TaxFieldsFragmentDoc,
  useGetAdProductsForAdEditingLazyQuery,
  useGetAdProductsForAdEditingQuery,
  useGetAdProductsForAdEditingSuspenseQuery,
  useGetAdProductsForAdPostingLazyQuery,
  useGetAdProductsForAdPostingQuery,
  useGetAdProductsForAdPostingSuspenseQuery
};
